import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { Icon } from '@ibk/shared-ui';
import { EMISSOR_ORDER_STATUS_LABELS, EmissorOrderScreenStatus } from '../../types/emissor-order-history';
import styles from './OrderStatusBadge.module.css';
const STATUS_VISUALS = {
    [EmissorOrderScreenStatus.GENERATING_BILLING]: { className: styles.neutral, icon: 'loaderGray' },
    [EmissorOrderScreenStatus.PENDING_PAYMENT]: { className: styles.warning, icon: 'warning' },
    [EmissorOrderScreenStatus.RELEASING_CREDIT]: { className: styles.info, icon: 'informationBlueFilled' },
    [EmissorOrderScreenStatus.CREDIT_RELEASED]: { className: styles.success, icon: 'successGreenFilled' },
    [EmissorOrderScreenStatus.CANCELLED]: { className: styles.error, icon: 'errorRedFilled' },
};
export const OrderStatusBadge = ({ status, 'data-testid': testId }) => {
    const { t } = useTranslation();
    const statusLabel = t(EMISSOR_ORDER_STATUS_LABELS[status]);
    const visual = STATUS_VISUALS[status] ?? STATUS_VISUALS[EmissorOrderScreenStatus.PENDING_PAYMENT];
    return (_jsxs("span", { className: `${styles.tag} ${visual.className}`, "data-testid": testId, title: statusLabel, children: [_jsx(Icon, { name: visual.icon, alt: '', "aria-hidden": true, className: styles.tagIcon }), _jsx("span", { className: styles.tagLabel, children: statusLabel })] }));
};
